// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2fblr","topBottomGutter":"Layout_topBottomGutter__3QxnU"};